export function formatPhoneNumber(value: string): string {
  if (!value) {
    return '';
  }
  const number = value.replace(/\D/g, '').substring(0, 10);
  const areaCode = number.substring(0, 3);
  const middle = number.substring(3, 6);
  const last = number.substring(6, 10);

  if (number.length > 6) {
    return `(${areaCode}) ${middle}-${last}`;
  } else if (number.length > 3) {
    return `(${areaCode}) ${middle}`;
  }

  return number;
}

export function formatCanadaPostalCode(value: string): string {
  if (!value) {
    return '';
  }

  // Remove any non-alphanumeric characters and limit to 6 characters
  const cleanedValue = value.replace(/\W/g, '').substring(0, 6);

  // Convert letters to uppercase
  const uppercasedValue = cleanedValue.toUpperCase();

  // Extract first 3 characters and last 3 characters
  const first = uppercasedValue.substring(0, 3);
  const last = uppercasedValue.substring(3, 6);

  // Format as A1A 1A1 if the length is more than 3 characters
  if (uppercasedValue.length > 3) {
    return `${first} ${last}`;
  }

  return uppercasedValue;
}

export const formatPostCode = (node, formatFunction) => {
  if (formatFunction) {
    function updateValue(e) {
      node.value = formatFunction(node.value);
    }

    node.addEventListener('input', updateValue);
    node.addEventListener('paste', updateValue);

    // Format on intial hydration
    node.value = formatFunction(node.value);

    return {
      destroy() {
        node.removeEventListener('input', updateValue);
        node.removeEventListener('paste', updateValue);
      },
    };
  }
};

export function isValidPhoneNumber(value) {
  const phoneNumberPattern = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
  return phoneNumberPattern.test(value);
}

export function isValidZipCode(zip: string) {
  const zipRegex =
    /^\d{5}(?:[-\s]\d{4})?$|^[ABCEGHJKLMNPRSTVXY]\d[A-Z] ?\d[A-Z]\d$/;
  return zipRegex.test(zip);
}

export function isValidEmailAddress(value: string) {
  return /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value);
}

export function isValidUrl(value: string): boolean {
  try {
    const urlRegex =
      /^(https?:\/\/)?(www\.)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+([a-z]{2,24}))(:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(\#[-a-z\d_]*)?$/i;
    const match = value.match(urlRegex);
    const isValid = !!(match && match[0] === value);

    // If the URL contains 'www', it should also contain a minimum of two dots
    if (value.includes('www') && (value.match(/\./g) || []).length < 2) {
      return false;
    }

    return isValid;
  } catch (e) {
    return false;
  }
}
